import { Input } from "@/components/ui/input";

interface Props {
  question: string;
  value: string;
  onChange: (v: string) => void;
  className?: string;
}

// Simple math captcha used as a fallback when reCAPTCHA fails or returns
// a low score. Visible only when the backend asks for it.
export const MathChallenge = ({ question, value, onChange, className }: Props) => (
  <div className={`p-4 border border-primary/40 bg-primary/5 ${className ?? ""}`}>
    <p className="text-sm font-body mb-2">
      Quick check — please answer to confirm you're human:
    </p>
    <div className="flex items-center gap-3">
      <span className="font-mono text-lg">{question} =</span>
      <Input
        type="number"
        inputMode="numeric"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-24"
        autoFocus
        required
      />
    </div>
  </div>
);